import { useCallback, useEffect, useState } from 'react';
import { api } from '../../../services/api';
import { useWorkspace } from '../WorkspaceContext';

export const METHOD_LABELS = {
  card: 'Card',
  cash: 'Cash',
  transfer: 'Bank transfer',
  mobile_money: 'Mobile money',
  online: 'Online',
  flutterwave: 'Online',
};

export const KIND_LABELS = {
  deposit: 'Deposit',
  full_payment: 'Full payment',
  balance: 'Balance',
};

export const PAYOUT_LABELS = {
  paid_out: 'Sent to wallet',
  split: 'Settled to account',
  pending_payout: 'Cleared to send',
  settling: 'Settling',
  failed: 'Payout failed',
  collected: 'Collected',
  unpaid: 'Unpaid',
};

export const useWorkspaceSales = () => {
  const { activeLocation } = useWorkspace();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [retrying, setRetrying] = useState(false);

  const load = useCallback(async () => {
    if (!activeLocation?.id) {
      setLoading(false);
      setData(null);
      return;
    }
    setLoading(true);
    const result = await api.getWorkspaceSales(activeLocation.id);
    if (result.error) {
      setError(result.error);
      setData(null);
    } else {
      setError('');
      setData(result.data);
    }
    setLoading(false);
  }, [activeLocation?.id]);

  useEffect(() => {
    load();
  }, [load]);

  const retryPayouts = async (appointmentId = null, amount = null, confirmAccountNumber = null) => {
    setRetrying(true);
    const result = await api.retryWorkspacePayouts(
      activeLocation?.id,
      appointmentId,
      amount,
      confirmAccountNumber
    );
    setRetrying(false);
    if (result.error) return result;
    setError('');
    await load();
    if (result.data?.failed > 0) {
      const count = result.data.failed;
      setError(
        `${count} payout${count === 1 ? '' : 's'} could not be sent. Check the connected account and try again.`
      );
    }
    return result;
  };

  const cashOut = (amount, confirmAccountNumber) =>
    retryPayouts(null, amount, confirmAccountNumber);

  return { data, loading, error, retrying, refresh: load, retryPayouts, cashOut, location: activeLocation };
};
